function getCountfun(getArray){
  return new Promise((resolve, reject) => {
    let tempArray = [];
    let shippingidNext=getArray.split(/[\n]+/);
    let shippingidComma=getArray.split(/[,]+/);

    if(shippingidNext.length > 1) {
      $.each(shippingidNext, (key,sid)=>{
        if(sid != null && sid !='' && sid != ' '){
          tempArray.push(sid.trim());
        }
      })
    } else if(shippingidComma.length >= 1) {
      $.each(shippingidComma, (key,sid)=>{
        if(sid != null && sid !='' && sid != ' '){
          tempArray.push(sid.trim());
        }
      })
    }
    if(tempArray.length > 100 || tempArray.length > 100){
      resolve(false);
    }else{
      resolve(true);
    }

  }).catch(function(error) {
    console.log('Error for Getfunction',error);
  })
}


export { getCountfun }



// WEBPACK FOOTER //
// ./src/common/validations.js